module.exports = __webpack_public_path__ + "build/desktop/img/tariff.3d0307f760148c82e6539938dd2b5245.svg";